import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Bar as RCBar } from 'recharts'
import { store } from '../../../../app/store'
import { isInValidValue } from '../../../helpers/value'
import { Element } from '../../html/element'
import { selectChartData, setChartData } from '../store'

class Bar extends RCBar {
  constructor(props) {
    super(props)
    this.state = { isActive: true }

    this.setIsActive = this.setIsActive.bind(this)
    this.onMouseOver = this.onMouseOver.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)
  }

  setIsActive(active) {
    this.setState({ isActive: active })
  }

  onMouseOver() {
    if (!this.props.chartId) return
    store.dispatch(
      setChartData({
        chartId: this.props.chartId,
        activeKey: this.props.dataKey,
        activeTooltip: true,
      }),
    )
  }

  onMouseLeave() {
    if (!this.props.chartId) return
    store.dispatch(
      setChartData({
        chartId: this.props.chartId,
        activeKey: undefined,
        activeTooltip: false,
      }),
    )
  }

  render() {
    const { children, showLabelEmpty, label, ...rest } = this.props

    let customLabel = label

    if (showLabelEmpty) {
      customLabel = <CustomLabel originLabel={label} barProps={this.props} />
    }

    return (
      <>
        <RCBar
          onMouseOver={this.onMouseOver}
          onMouseLeave={this.onMouseLeave}
          opacity={this.state.isActive ? 1 : 0.4}
          label={customLabel}
          {...rest}
        >
          {children}
        </RCBar>
        <g>
          <foreignObject>
            <ListenData
              chartId={this.props.chartId}
              dataKey={this.props.dataKey}
              setIsActive={this.setIsActive}
            />
          </foreignObject>
        </g>
      </>
    )
  }
}

const CustomLabel = (props) => {
  const {
    x,
    y,
    width,
    height,
    value,
    originLabel,
    barProps: { xAxis, yAxis, layout, stackId, showLabelEmpty },
  } = props

  const xCoordinate = layout === 'vertical' ? xAxis.scale(0) : x
  const yCoordinate = layout === 'horizontal' ? yAxis.scale(0) - 20 : y
  const labelWidth = layout === 'vertical' ? 20 : width
  const labelHeight = layout === 'horizontal' ? 20 : height

  const allowShow =
    typeof showLabelEmpty === 'function' ? showLabelEmpty(props) : true

  if (allowShow && (stackId ? !value : isInValidValue(value))) {
    return (
      <g className="pointerEventsNone">
        <foreignObject
          x={xCoordinate}
          y={yCoordinate}
          width={labelWidth}
          height={labelHeight}
        >
          <Element
            className="h100 w100 dFlex alignItemsCenter justifyContentCenter"
            style={{ fontSize: 10, color: '#3a414b' }}
          >
            {/* {EMPTY_VALUE}/ */}
          </Element>
        </foreignObject>
      </g>
    )
  }

  if (React.isValidElement(originLabel)) {
    return React.cloneElement(originLabel, props)
  }

  if (typeof originLabel === 'function') {
    return originLabel(props)
  }

  return null
}

const ListenData = ({ chartId, dataKey, setIsActive }) => {
  const activeKey = useSelector(
    selectChartData(chartId, (data) => data.activeKey),
  )

  useEffect(() => {
    const active = !activeKey || activeKey === dataKey
    setIsActive(active)
  }, [activeKey, dataKey])

  return <></>
}

Bar.propTypes = {
  // All rechart tooltip content props
  showLabelEmpty: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
}

Bar.defaultProps = {
  ...RCBar.defaultProps,
  isAnimationActive: false,
  showLabelEmpty: true,
}

export default Bar
